import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SvgUser } from 'data/common/iconsvg';
import { FHEContainer, FHEContainerScroll, FHETitle } from 'data/components';
import FormUser from './Form/FormUser';
import { addUser } from '../../data/Users/actions';

class UserAdd extends PureComponent {
    static propTypes = {
        addUser: PropTypes.func.isRequired
    };

    render() {
        const { addUser } = this.props;

        return (
            <FHEContainer withBackIcon>
                <FHETitle title={Translator.translate('general.addUser')} Icon={SvgUser} />
                <FHEContainerScroll>
                    <FormUser sendDataFunc={addUser} type="add" />
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { addUser }), dispatch)
    )(UserAdd)
);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/User/add.js